import { type SerializedPageStructure } from '@wix/document-services-types'

export const setPageLegacyIndexability = ({
  page,
  pageIsIndexable,
}: {
  page: SerializedPageStructure
  pageIsIndexable: boolean
}) => ({
  ...page,
  data: { ...page.data, indexable: pageIsIndexable },
})
